import { combineReducers } from '@reduxjs/toolkit';
import StepwalletSlice from './StepwalletSlice';
import leaderTreeSlice from './leaderTreeSlice';
import migrationHistorySlice from './migrationDataSlice';
import migrationAmountDataSlice from './migrationAmountDataSlice';
import UserDataSlice from './userDataSlice';

const rootReducer = combineReducers({
    Stepwallet: StepwalletSlice,
    LeaderTree: leaderTreeSlice,
    migrationHistory: migrationHistorySlice,
    migrationAmountData: migrationAmountDataSlice,
    userData: UserDataSlice,
});

export default rootReducer;